// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DigitalPaymentV1ClientGeneratedTransactionWebhookPayload } from './digitalPaymentV1ClientGeneratedTransactionWebhookPayload.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DigitalPaymentV1ClientGeneratedWebhook {
    'eventId': string;
    'createdTime': Moment;
    'type': string;
    'programId': string;
    'data': DigitalPaymentV1ClientGeneratedTransactionWebhookPayload | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DigitalPaymentV1ClientGeneratedWebhook>> = [
        {
            "name":     "eventId",
            "baseName": "eventId",
            "type":     "string"
        },
        {
            "name":     "createdTime",
            "baseName": "createdTime",
            "type":     "Date"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
        {
            "name":     "programId",
            "baseName": "programId",
            "type":     "string"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "DigitalPaymentV1ClientGeneratedTransactionWebhookPayload"
        },
    ];

    static getAttributeTypeMap() {
        return DigitalPaymentV1ClientGeneratedWebhook.attributeTypeMap;
    }
}
